import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../landingAssets/css/bootstrap.min.css';
import '../../landingAssets/css/custom-animated.css';
import '../../landingAssets/css/default.css';
import '../../landingAssets/css/font-awesome.min.css';
import '../../landingAssets/css/magnific-popup.css';
import '../../landingAssets/css/magnific.dark.css';
import '../../landingAssets/css/magnific.rtl.css';
import '../../landingAssets/css/main.css';
import '../../landingAssets/css/style.css';

import Loader from '../landing/loder/Loader.jsx';
import Drawer from '../landing/Mobile/Drawer.jsx';
import useToggle from '../landing/Hooks/useToggle.js';
import FooterHomeOne from '../landing/Home/FooterHomeOne.jsx';
import BackToTop from '../landing/BackToTop.jsx';
import UpgradeModuleCartPage from './UpgradeModuleCartPage.js';

import { useSelector } from 'react-redux';
import { UserAuth } from '../auth/Auth.js';

function UpgradePlan() {
  const { Logout, userDetailsLogin, companyDetails } = UserAuth();
  const skipOrGetStart = useSelector((state) => state.skipGet);

  const [loading, setLoading] = useState(true);
  const [drawer, drawerAction] = useToggle(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && (
        <div className="appie-loader active">
          <Loader />
        </div>
      )}
      <div className={`appie-visible upgrade-page ${!loading ? 'active' : ''}`}>
        <header className="user-account-header-wrap">
          <div className="container">
            <div className="user-account-header-cont">
              <div className="logo-wrap">
                <Link to="/">
                  <img
                    src={process.env.PUBLIC_URL + 'assets/images/logo-navy.png'}
                    alt="Logo"
                    className="img-fluid brand-name"
                  />
                </Link>
              </div>
              <button
                type="button"
                className="gth-btn-outline d-flex align-items-center"
                onClick={Logout}
                style={{ cursor: 'pointer' }}
              >
                Sign Out <i className="fi fi-br-sign-out-alt mt-1 ms-2"></i>
              </button>
            </div>
          </div>
        </header>

        <div className="d-flex justify-content-center mt-4">
          <ul className="nav nav-tabs gth-tabs user-account-tab border-bottom-0" role="tablist">
            <li className="nav-item" role="presentation">
              <Link className="nav-link" to="/dashboard">
                <i className="fi fi-sr-user"></i> Profile Information
              </Link>
            </li>
            <li className="nav-item" role="presentation">
              <Link className="nav-link" to="/dashboard">
                <i className="fi fi-sr-users"></i> Users List
              </Link>
            </li>
            <li className="nav-item" role="presentation">
              <Link className="nav-link active" to="/dashboard">
                <i className="fi fi-sr-credit-card"></i> Plan Details
              </Link>
            </li>
            <li className="nav-item" role="presentation">
              <Link className="nav-link" to="/dashboard">
                <i className="fi fi-ss-receipt"></i> Payment History
              </Link>
            </li>
          </ul>
        </div>

        <UpgradeModuleCartPage skipOrGetStart={skipOrGetStart} />

        <FooterHomeOne />
        <BackToTop />
      </div>
    </>
  );
}

export default UpgradePlan;
